import { render, staticRenderFns } from "./AthleteAccessControlUserRow.vue?vue&type=template&id=12c21c44&scoped=true&"
import script from "./AthleteAccessControlUserRow.vue?vue&type=script&lang=ts&"
export * from "./AthleteAccessControlUserRow.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteAccessControlUserRow.vue?vue&type=style&index=0&id=12c21c44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c21c44",
  null
  
)

export default component.exports